const rankings = [
  { rank: 1, title: '妖精视频 · 本周热播TOP50合集', tag: '影视大全', hot: '🔥 32.8万', change: 'up' },
  { rank: 2, title: '桃花视频 · 独家精品推荐专题', tag: '独家专题', hot: '🔥 28.1万', change: 'up' },
  { rank: 3, title: '苹果视频 · 高清影视大全新片', tag: '高清精选', hot: '🔥 25.6万', change: 'up' },
  { rank: 4, title: '榴莲视频 · 热门视频合集周榜', tag: '周榜', hot: '23.4万', change: 'down' },
  { rank: 5, title: '豆花视频 · 经典回顾精选系列', tag: '经典回顾', hot: '19.8万', change: 'up' },
  { rank: 6, title: '菠萝视频 · 最新热门视频推荐', tag: '最新推荐', hot: '17.2万', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门榜单</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              影视大全实时热度排行，热门视频合集每日更新
            </p>
          </div>

          <div className="space-y-3">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200/60 transition-all cursor-pointer group"
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                  <span className={`w-7 h-7 rounded-lg flex items-center justify-center ${
                    item.change === 'up' ? 'bg-primary-50 text-primary-600' :
                    item.change === 'new' ? 'bg-accent-50 text-accent-600' :
                    'bg-secondary-100 text-secondary-600'
                  }`}>
                    <i className={`text-sm ${
                      item.change === 'up' ? 'ri-arrow-up-line' :
                      item.change === 'new' ? 'ri-sparkling-line' :
                      'ri-arrow-down-line'
                    }`}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}